const PROFILE_ACTION_TYPES = {
  LOAD_PROFILE: 'user/LOAD_PROFILE',
};

export default PROFILE_ACTION_TYPES;
